export const DEFAULT_GROUP_NAME = 'No value';

export const SWIMLANE_NO_VALUE_ID = 'SWIMLANE_NO_VALUE_ID';

export const MESSAGE_CREATE_DOC_DISABLED_HAS_NEXT_PAGE = 'Scroll down and load all to create new at bottom';
export const MESSAGE_CREATE_DOC_DISABLED_BOARD_CONFIG = 'Current view configuration doesn\'t allow creation';
